<template>
  <div class="py-4">
    <b-container>
      <TableCompanies />

      <ModalAddCompany />
      <ModalCompanyRole />
    </b-container>
  </div>
</template>

<script>
import TableCompanies from '@components/TableCompanies'
import ModalAddCompany from '@components/ModalAddCompany'
import ModalCompanyRole from '@components/ModalCompanyRole'

export default {
  title: 'Companies',
  components: {
    TableCompanies,
    ModalAddCompany,
    ModalCompanyRole
  },
  inject: ['companySvc'],
  beforeDestroy() {
    this.companySvc.set('list', null)

    this.$bus.destroyEvents()
  }
}
</script>
